import { useMutation } from "@apollo/client"
import { GQL_BRAND, MUTATION_UPDATEFILEBRAND } from "../../../shared/Services/Graphql/Graphql"
import { ModalFilesBrand } from "../modal_files_brand"
import { useState } from "react";

// Defina uma interface para o tipo de imagem definida
interface DefinedImageType {
  id: string;
  url: string;
  name: string;
  width?: number;
  height?: number;
}

export const UpdateFileImage = ({ file, idBrand }) => {
  const [activeModal, setActiveModal] = useState(false)
  const [definedImage, setDefinedImage] = useState<DefinedImageType | null>(null)

  const [updateFile] = useMutation(MUTATION_UPDATEFILEBRAND, {
    awaitRefetchQueries: true,
    refetchQueries: [{ query: GQL_BRAND, variables: { id: idBrand } }],
  })

  function update_file(idFile: string) {
    updateFile({
      variables: {
        id: file.id,
        data: {
          file: idFile,
        },
      },
    })
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <div className="file_edit_image">
      <figure className="file_image" onClick={() => setActiveModal(true)}>
        <img src={file.file?.url} alt={file.file?.name} />
      </figure>
      {activeModal && (
        <ModalFilesBrand
          setActiveModal={setActiveModal}
          setDefinedImage={setDefinedImage}
          update={update_file}
          title={`file - ${file.type}`}
        />
      )}
    </div>
  )
}
